import { render, staticRenderFns } from "./EntityDeleteControl.vue?vue&type=template&id=0e152c32"
import script from "./EntityDeleteControl.vue?vue&type=script&lang=js"
export * from "./EntityDeleteControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports